export class InvestigationWorkNoteEntity {
  public id!: string;
  public body!: string;
  public senderUserId!: string | null;
  public senderName!: string | null;
  public senderFirstName!: string | null;
  public senderLastName!: string | null;
  public noteType!: number;
  public createdOn!: string;

  public get isSystemGenerated(): boolean {
    return (
      this.senderUserId === null ||
      this.senderName === null ||
      this.senderFirstName === null ||
      this.senderLastName === null
    );
  }

  public get displaySenderName(): string {
    if (this.isSystemGenerated) return 'System';
    return this.senderName ?? 'Unknown';
  }

  public get senderInitials(): string {
    if (this.isSystemGenerated) return 'SY';
    const firstInitial = this.senderFirstName?.charAt(0) ?? '';
    const lastInitial = this.senderLastName?.charAt(0) ?? '';
    return `${firstInitial}${lastInitial}`.toUpperCase();
  }
}
